import en_GB from "../languages/en-GB.json";
import sv_SE from "../languages/sv-SE.json";
import nb_NO from "../languages/nb-NO.json";
import da_DK from "../languages/da-DK.json";
import fr_FR from "../languages/fr-FR.json";

export const resources = {
	"en-GB": {
		translation: en_GB,
	},
	"sv-SE": {
		translation: sv_SE,
	},
	sv: {
		translation: sv_SE,
	},
	"nb-NO": {
		translation: nb_NO,
	},
	"da-DK": {
		translation: da_DK,
	},
	"fr-FR": {
		translation: fr_FR,
	},
} as const;

export const supportedLanguages = Object.keys(resources).flatMap((key) => [
	key,
	key.substring(0, 2),
]) as Array<keyof typeof resources>;
